import { makeStyles } from "tss-react/mui";

interface IStyleParams {
    isMobile: boolean;
}

export const useSharedErrorStyles = makeStyles<IStyleParams>()((theme, { isMobile }) => ({
    titleContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    warningIcon: {
        width: "22px",
        height: "22px",
        color: theme.palette.primary.main,
        flexShrink: 0,
    },
    errorTitle: {
        color: theme.palette.primary.main,
        marginBottom: 0,
        fontWeight: theme.typography.fontWeightRegular,
    },
    errorMessage: {
        color: theme.palette.secondary.main,
        marginBottom: theme.spacing(1),
    },
    retryContainer: {
        display: "flex",
        alignItems: "center",
        justifyContent: isMobile ? "center" : "space-between",
        flexDirection: isMobile ? "column" : "row",
        gap: theme.spacing(2),
        padding: theme.spacing(2),
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${theme.palette.divider}`,
        marginBottom: theme.spacing(2),
        flexWrap: "wrap",
    },
    retryIcon: {
        width: "34px",
        height: "34px",
        flexShrink: 0,
    },
    retryMessage: {
        color: theme.palette.secondary.main,
        maxWidth: "100%",
        flex: 1,
        fontWeight: theme.typography.fontWeightRegular,
    },
    retryIconContainer: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
    },
    retryLink: {
        color: theme.palette.primary.main,
        textTransform: "none",
        paddingInline: theme.spacing(4),
        fontFamily: theme.typography.fontFamily,
        textDecoration: "underline",
        ...(isMobile && {
            textAlign: "center",
        }),
    },
    removeButtonContainer: {
        display: "flex",
        justifyContent: isMobile ? "center" : "flex-end",
        paddingTop: theme.spacing(2),
    },
}));
